export const EVALUATION_STORAGE_KEY = "anamneseEvaluationV2";

function readRaw() {
  try {
    const raw = localStorage.getItem(EVALUATION_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function writeRaw(value) {
  const encoded = JSON.stringify(value);
  try {
    localStorage.setItem(EVALUATION_STORAGE_KEY, encoded);
  } catch {
    // noop
  }
}

export function persistAnamneseEvaluation({
  evaluation,
  anmId,
  submissionUuid,
  isPreview,
  audience,
  personaId,
} = {}) {
  if (!evaluation) return null;
  const previous = readRaw();
  const payload = {
    evaluation,
    anm_id: anmId ?? null,
    submissionUuid: submissionUuid ?? null,
    isPreview: Boolean(isPreview),
    audience: audience ?? previous?.audience ?? null,
    persona_id: personaId ?? null,
    savedAt: Date.now(),
  };
  writeRaw(payload);
  
  if (anmId && !isPreview) {
    try {
      localStorage.setItem("currentAnamnesis", String(anmId));
    } catch {
      // noop
    }
  }
  return payload;
}

export function readAnamneseEvaluation() {
  const stored = readRaw();
  if (!stored || typeof stored !== "object" || !stored.evaluation) return null;
  return stored;
}

export function peekStoredSubmissionUuid() {
  return readAnamneseEvaluation()?.submissionUuid || null;
}

export function clearAnamneseEvaluation() {
  try {
    localStorage.removeItem(EVALUATION_STORAGE_KEY);
    localStorage.removeItem(EVALUATION_STORAGE_KEY); // Clean up legacy
  } catch {
    // noop
  }
}

